import React from "react";

const DEFAULT_HERO_IMAGE = "/template/assets/images/auth/auth-img.png";

export default function AuthLayout({ children, heroImage = DEFAULT_HERO_IMAGE, heroAlt = "Way2Umrah" }) {
  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center px-24">
          <img src={heroImage} alt={heroAlt} className="auth-hero-image" />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        {children}
      </div>
    </section>
  );
}
